import { useId, type SVGProps } from 'react';

export const AiArrowDownGradient = (props: SVGProps<SVGSVGElement>) => {
  const uniqueId = useId();
  const paint0Id = `paint0_linear_20877_29960_${uniqueId}`;

  const paint0Url = `url(#${paint0Id})`;

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="path-1-inside-1_22126_48768" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 9.99715L12 14.9971L7 9.99716L7.70711 9.29005L12 13.5829L16.2929 9.29004L17 9.99715Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 9.99715L12 14.9971L7 9.99716L7.70711 9.29005L12 13.5829L16.2929 9.29004L17 9.99715Z"
        fill="white"
      />
      <path
        d="M17 9.99715L17.7071 10.7043L18.4142 9.99715L17.7071 9.29004L17 9.99715ZM12 14.9971L11.2929 15.7043L12 16.4114L12.7071 15.7043L12 14.9971ZM7 9.99716L6.29289 9.29005L5.58578 9.99716L6.29289 10.7043L7 9.99716ZM7.70711 9.29005L8.41421 8.58295L7.70711 7.87584L7 8.58295L7.70711 9.29005ZM12 13.5829L11.2929 14.29L12 14.9971L12.7071 14.29L12 13.5829ZM16.2929 9.29004L17 8.58293L16.2929 7.87583L15.5858 8.58293L16.2929 9.29004ZM7.70711 9.29005L7 8.58295L6.29289 9.29005L7 9.99716L7.70711 10.7043L8.41421 9.99716L7.70711 9.29005ZM12 13.5829L12.7071 12.8758L8.41421 8.58295L7.70711 9.29005L7 9.99716L11.2929 14.29L12 13.5829ZM16.2929 9.29004L15.5858 8.58293L11.2929 12.8758L12 13.5829L12.7071 14.29L17 9.99715L16.2929 9.29004ZM17 9.99715L17.7071 9.29004L17 8.58293L16.2929 9.29004L15.5858 9.99715L16.2929 10.7043L17 9.99715ZM12 14.9971L12.7071 15.7043L17.7071 10.7043L17 9.99715L16.2929 9.29004L11.2929 14.29L12 14.9971ZM7 9.99716L6.29289 10.7043L11.2929 15.7043L12 14.9971L12.7071 14.29L7.70711 9.29005L7 9.99716Z"
        fill={paint0Url}
        mask="url(#path-1-inside-1_22126_48768)"
      />
      <defs>
        <linearGradient id={paint0Id} x1="6.57746" y1="10.4111" x2="15.6839" y2="17.325" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E60000" />
          <stop offset="0.541564" stopColor="#7029CC" />
          <stop offset="1" stopColor="#0F558C" />
        </linearGradient>
      </defs>
    </svg>
  );
};
